import { Component, Output, Input, EventEmitter } from '@angular/core';
import { SocialSharingProvider } from '../../providers/social-sharing/social-sharing';
import { ToolsProvider } from '../../providers/tools/tools';
import { ToastController } from 'ionic-angular';
import { CrudApiProvider } from '../../providers/crud-api/crud-api';
import { UserProvider } from '../../providers/user/user';
import * as moment from 'moment';
import * as debug from 'debug';

declare let CmKit: any;

@Component({
  selector: 'invite-slideover',
  templateUrl: 'invite-slideover.html',
})
export class InviteSlideoverComponent {
  @Input() inviteKarmaMiles = 0;
  @Output() close = new EventEmitter<boolean>();

  text =
    "Check out the CDLLife App!\n\nIt's an online community for truckers. I use it to chat with other drivers, find trucking news, parking, use the free trip planner (with truck-optimized GPS routing) & more!\nhttp://onelink.to/cdllifeapp ";
  inviteTextSent = false;
  inviteCoppied = false;
  inviteType = '';
  maxInvitesReached = false;
  howManyDaysSinceLastInvite;
  dateOfLastInvite;
  friendTotal;

  constructor(
    public socialSharingService: SocialSharingProvider,
    public tools: ToolsProvider,
    public crudApi: CrudApiProvider,
    public user: UserProvider,
    public toastCtrl: ToastController
  ) {}

  closeSlideOver() {
    this.close.emit(false);
    this.inviteTextSent = false;
  }

  async timeSinceLastInvite(inviteType) {
    this.friendTotal = this.user.info.stats.events.friend || 0;

    if (!this.maxInvitesReached) {
      localStorage.setItem('currentFriendsTotal', this.friendTotal);
      localStorage.setItem('invitedFriendDate', JSON.stringify(moment()));
    }

    this.dateOfLastInvite = JSON.parse(
      localStorage.getItem('invitedFriendDate')
    );

    this.howManyDaysSinceLastInvite = moment().diff(
      this.dateOfLastInvite,
      'days'
    );

    if (this.howManyDaysSinceLastInvite > 6) {
      await this.crudApi
        .put(`/api/users/${this.user.info._id}/invite`)
        .then(res => {
          this.maxInvitesReached = false;
          this.sendTextInvite(inviteType);
        })
        .catch(e => {
          console.error('error', e);
        });
    } else {
      this.sendTextInvite(inviteType);
    }
  }

  async sendTextInvite(inviteType) {
    const toast = this.toastCtrl.create({
      message: '✓ Invite link successfully coppied',
      position: 'top',
      duration: 3000,
      cssClass: 'invite-toast',
    });

    await this.crudApi
      .post(`/api/users/${this.user.info._id}/invite`)
      .then(res => {
        if (res.data.errorType === 'maxInvitesSent') {
          this.maxInvitesReached = true;
          alert('You have reached your weekly invite allowance');
        } else {
          if (inviteType === 'text') {
            this.socialSharingService
              .shareApp(this.text)
              .then(d => {
                this.inviteTextSent = true;
                this.tools.logAnalyticsEvent(
                  'trackCustom',
                  'send-external-invite'
                );
              })
              .catch(e => {
                console.error('invite sharing error', e);
              });
          } else {
            this.tools.copyToClipboard(this.text);
            this.inviteCoppied = true;
            setTimeout(() => {
              toast.present();
              this.closeSlideOver();
              this.inviteCoppied = false;
            }, 400);
          }
        }
      })
      .catch(e => {
        console.error('ERROR Inviting user == ', e);
        this.tools.logAnalyticsEvent(
          'trackCustom',
          'error-sending-external-invite'
        );
      });
  }
}



// WEBPACK FOOTER //
// ./src/components/invite-slideover/invite-slideover.ts